import { Dropdown } from 'antd'
import React from 'react'

import { KeyLabel } from '../../types/common.type'

type PureDropdownProps = {
  button: React.ReactNode
  items: KeyLabel<any>[]
  onSelected?: (key: string) => void
}

export const PureDropdown = ({ button, items, onSelected }: PureDropdownProps) => {
  const handleMenuClick = (e: any) => {
    onSelected?.(e.key)
  }

  return (
    <Dropdown menu={{ items, onClick: handleMenuClick }}>
      <span>{button}</span>
    </Dropdown>
  )
}
